<ion-header>
  <ind-page-title [viewData]="pageTitleViewData" (onControlClick)='onPageTitleControlClick($event)'></ind-page-title>
  <div class="searchbar-wrapper">
    <ion-searchbar placeholder="{{searchPlaceholder}}" [(ngModel)]="searchInput" (ionInput)="handleSearch()"></ion-searchbar>
    <div class="searchbar-overlay">
      <!-- <div class="section-header-button-text" (click)="clearFilterResults()"> {{ 'CLEAR_FILTER' | translate }} </div> -->
      <ion-button tooltip="{{'FILTERS' | translate}}" class="searchbar-overlay-button" fill="clear" (click)="onFilterClick($event)">
        <ion-icon class="searchbar-overlay-button-filter-icon contactTimelineFilterIcon" slot="icon-only" src="assets/imgs/header_filter.svg" [class.timeline-filter-empty]="_allTimelineActivities?.length == 0"></ion-icon>
        <span *ngIf="filterButtonBadgeCount > 0" class="searchbar-filter-badge">{{ filterButtonBadgeCount }}</span>
      </ion-button>
    </div>
  </div>
  <!--Customer Glance Card-->
  <glance-card *ngIf="contactGlanceViewData" [viewData]="contactGlanceViewData"
    [quickActions]="contactQuickActions" [hasQuickActionOverflow]="hasQuickActionOverflow"
    (onControlClick)="onQuickGlanceControlClick($event)"
    (quickActionOverflow)="openQuickActionOverflow($event)"> </glance-card>
</ion-header>
<ion-content>
  <ind-section-header [viewData]='timelineSectionHeader'></ind-section-header>
  <ion-list class="time-line-list" *ngIf="viewTimelineItems.length > 0">
      <timeline-item *ngFor="let item of viewTimelineItems; trackBy: trackById" [inputData]="item"
        (clickedOnHeader)="openDetails($event,item)"></timeline-item>
      <ion-infinite-scroll (ionInfinite)="doInfinite($event)" threshold="30%">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
      </ion-infinite-scroll>
  </ion-list>
  <ion-list>
    <div class="no-data-message" *ngIf="viewTimelineItems.length == 0 && contactService.isContactDetailsLoaded">
      {{(isJourney? 'CONTACT_NO_JOURNEY' : 'NO_ACTIVITIES_CAP') | translate}}</div>
  </ion-list>
</ion-content>
<footer-toolbar *ngIf="footerService.shouldShowFooter$ | async" (buttonClicked)="onFooterButtonClicked($event)"
  [footerView]="'detailView'" [selectedView]="'contacts'"></footer-toolbar>